import urlConstants from '~/lib/constants/url.constants';
import { CacheTag } from '~/store/services/CacheTag';

import api from './api';

export type GetAppUsersRequest = {
  patientId: string;
  includeGeneral?: boolean;
  includeInactive?: boolean;
};

type GetAppUsersOptions = {
  'include-general': boolean;
  'include-inactive': boolean;
};

export type GetUsersInBatchRequest = {
  userIds?: string[];
  authIds?: string[];
};

const appUsersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAppUsers: build.query<FamilyTaskAssignee[], GetAppUsersRequest>({
      keepUnusedDataFor: 5 * 60,
      providesTags: [CacheTag.AppUsers],
      query: ({
        patientId,
        includeGeneral,
        includeInactive,
      }: GetAppUsersRequest) => {
        const url = urlConstants.patients.getPatientTasksAppUsers(patientId);
        const params: GetAppUsersOptions = {
          'include-general': includeGeneral ?? false,
          'include-inactive': includeInactive ?? false,
        };
        return {
          params,
          url,
        };
      },
    }),
    getUserDetailsInBatch: build.query<UserDetails[], GetUsersInBatchRequest>({
      query: ({ userIds, authIds }) => ({
        params: {
          authId: authIds,
          id: userIds,
        },
        url: urlConstants.users.users,
      }),
    }),
  }),
});

export const { useGetAppUsersQuery, useGetUserDetailsInBatchQuery } =
  appUsersApi;
